module.exports = __webpack_public_path__ + "fonts/KFOmCnqEu92Fr1Mu7GxKOzY.455200cb.woff2";